// extracted by mini-css-extract-plugin
export default {"cursorContainer":"Cursor_cursorContainer__3Y83L","cursor":"Cursor_cursor__98OV1","arrow":"Cursor_arrow__8u8rV"};